import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { request } from "@/lib/coachQueries";

/**
 * Master v5 Prompt 26 — Bounded contextual AI explanation layer.
 * A client's own trigger always comes back `pending_coach_review` with
 * no `output` — the redaction happens server-side, never trusted to
 * the client bundle. Mirrors recommendationQueries.js's conventions.
 */
export function useExplanationForRecommendation(workspaceId, recId) {
  return useQuery({
    queryKey: ["explanation", workspaceId, recId],
    enabled: !!workspaceId && !!recId,
    queryFn: () => request(`/api/rehearsal-room/workspaces/${workspaceId}/recommendations/${recId}/explanations/latest`),
  });
}

export function useRequestExplanation(workspaceId, recId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => request(`/api/rehearsal-room/workspaces/${workspaceId}/recommendations/${recId}/explanations`, { method: "POST" }),
    onSuccess: (data) => qc.setQueryData(["explanation", workspaceId, recId], data),
  });
}

export function useDecideExplanation(workspaceId, recId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ expId, decision }) =>
      request(`/api/rehearsal-room/workspaces/${workspaceId}/explanations/${expId}/decision`, {
        method: "POST", body: JSON.stringify({ decision }),
      }),
    onSuccess: (data) => {
      qc.setQueryData(["explanation", workspaceId, recId], data);
      qc.invalidateQueries({ queryKey: ["coach-explanations-pending", workspaceId] });
    },
  });
}

export function useDisagreeExplanation(workspaceId, recId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ expId }) => request(`/api/rehearsal-room/workspaces/${workspaceId}/explanations/${expId}/disagree`, { method: "POST" }),
    onSuccess: (data) => qc.setQueryData(["explanation", workspaceId, recId], data),
  });
}
